import React, { useEffect, useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import Form from "../../ReusableComponents/Form";
import InputField from "../../ReusableComponents/InputField";
import RadioButtonField from "../../ReusableComponents/RadioButtonField";
import Button from "./Button";

export default function OnCompletePopup({ open, onClose, onRequestSubmit,request }) {
    const unit = (request?.owner?.settings?.units)
    // const unitLabel = unit.charAt(0).toUpperCase() + unit.slice(1) 
    const [type, setType] = useState(unit);
    const [areaValue, setAreaValue] = useState({ field_area: "" });
    const [submitButtonType, setSubmitButtonType] = useState("cancel");
    const [isFetchingUser, setIsFetchingUser] = useState(false)

    const isSubmitDisabled = !areaValue.field_area || isNaN(Number(areaValue.field_area)) || Number(areaValue.field_area) <= 0;

useEffect(() => {
    setType(unit);
}, [request]);
    return (
        <Modal
            header={"Area Covered"}
            open={open}
            onClose={() => {
                setSubmitButtonType("cancel")
                setType(unit)
                setAreaValue({field_area: ""});
                onClose()
            }}
            contentStyle={{ width: "470px", height: "auto", boxShadow: " 0px 1.02px 4.09px 6.14px rgba(118, 118, 118, 0.15)" }}
            divider={true}
            headerContainerStyle={{ padding: "20px 25px" }}
            headingStyle={{ fontSize: "16px", fontWeight: 600 }}
            iconSize={"18px"}
        >
            <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                <Form
                    onSubmitForm={(req) => {
                        onRequestSubmit(type, areaValue.field_area, submitButtonType);
                        console.log("Form submitted with:", { type, areaValue });
                    }}
                    initialValues={{ ...areaValue, status: type }}
                    style={{ display: 'flex', flexDirection: 'column', width: "100%", height: 'calc(100% - 65px)', padding: "20px 30px", gap: '20px' }}
                >
                    {(onSubmit, formValue) => (
                        <>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', width: '100%' }}>
                                <RadioButtonField
                                    name="status"
                                    options={[
                                        { label: unit || "Acre", value: unit },
                                        { label: "No. of Tank", value: "tank" },
                                    ]}
                                    defaultValue={type}
                                    radioStyle={{ height: "25px", width: "25px" }}
                                    handleChange={(value) => {
                                        setType(value);
                                        console.log("Selected Type:", type);
                                        setAreaValue({ field_area: "" });
                                    }}
                                />

                                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', gap: '30px' }}>
                                    {
                                        type === unit && (
                                    <InputField
                                        handleChange={value => {
                                            setAreaValue(prev => ({ ...prev, field_area: value }))
                                        }}
                                        disabled={isFetchingUser}
                                        label={`Area covered(${unit})`}
                                        placeholder={"Enter field area "}
                                        name={'field_area'}
                                        containerStyle={{width: "100%"}}
                                        // validation={NoOfUserValidation} //add validation
                                        validation={{
                                            required: 'Required',
                                            validate: (value) => {
                                                if (value == "") {
                                                    return 'Required'
                                                }
                                                else
                                                    if (value.match(/^\d*\.?\d*$/)) {
                                                        const decimalValue = parseFloat(value);
                                                        if (!isNaN(decimalValue) && (decimalValue < 0.1 || decimalValue > 1000.0)) {
                                                            return "Field area in the range of 0.1 to 1000"
                                                        }
                                                    } else if (value < 0) {
                                                        return "Field area in the range of 0.1 to 1000"
                                                    }
                                            }
                                        }}
                                        type={'number'}
                                    />
                                    )}

                                    {type === "tank" && (
                                    <InputField
                                        handleChange={value => {
                                            setAreaValue(prev => ({ ...prev, field_area: value }))
                                        }}
                                        disabled={isFetchingUser}
                                        label={"Area covered(tanks)"}
                                        placeholder={"Enter no. of tanks"}
                                        name={'field_area'}
                                        containerStyle={{width: "100%"}}
                                        validation={{
                                            required: 'Required',
                                            maxLength: {
                                                value: 3,
                                                message: 'Max allowed number is 999.',
                                            },
                                            validate: (value) => {
                                                if (isNaN(value)) {
                                                    return 'Must be a number.';
                                                } else if (value <= 0 || value > 999) {
                                                    return 'No. of tanks should be between 1 to 999';
                                                }
                                            },
                                            format: {
                                                value: /^[0-9]+$/,
                                                message: 'Must be a number.',
                                            },
                                        }}
                                        type={'number'}
                                    />
                                    )}
                                </div>
                            </div>
                            <div className="flex ml-auto ps-8  py-2 gap-6">
                                <Button
                                    color={"#606571"}
                                    variant={"outlined"}
                                    title={"Cancel"}
                                    width={"80px"}
                                    handleClick={() => {
                                        setSubmitButtonType("cancel")
                                        setType("acre")
                                        setAreaValue({field_area: ""});
                                        console.log(submitButtonType)
                                        onClose()
                                    }}
                                />
                                <Button
                                    color={"#0F5EFF"}
                                    isDisbaled={isSubmitDisabled}
                                    variant={"filled"}
                                    title={"Complete"}
                                    width={"80px"}
                                    hoverColor={"#1251D2"}
                                    handleClick={() => {
                                        setSubmitButtonType("submit");
                                    }}
                                />
                            </div>
                        </>
                    )}
                </Form>
            </div>

        </Modal>
    )
}